import request from '@/utils/request'

const http = request()

/**
 * 用户登录
 * @param {String} username
 * @param {String} password
 * @returns
 */
export const login = (username, password) => http.post('/login', { username, password })

export const listExpert = params => http.post('/user/list', params)

export const listCommunityUsers = params => http.post('/user/list', params)

export const saveUser = params => http.raw('/user/save', params)

export const listWxUser = params => http.post('/user/listWxUser', params)
